import i18n, { LOCALE_MAP } from '@/i18n';

function getLocale(): string {
  return LOCALE_MAP[i18n.language] || 'en-US';
}

/**
 * Format a date string/Date as a short date (e.g. "Jan 5, 2025")
 * using the current i18n locale. No tenant timezone (Scouts are cross-tenant).
 */
export function formatDate(date: string | Date | null | undefined): string {
  if (!date) return '-';
  const d = new Date(date);
  if (isNaN(d.getTime())) return '-';
  return new Intl.DateTimeFormat(getLocale(), {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(d);
}

/**
 * Format a number with locale-aware separators (e.g. 1,234 in en-US, 1.234 in de-DE).
 */
export function formatNumber(value: number): string {
  return new Intl.NumberFormat(getLocale()).format(value);
}
